export const BERTH_ROUTES = Object.freeze({
	BERTH_OVERVIEW: '/berth-overview',
	MAP_OVERVIEW: '/map-overview',
});
